'use client';

import { c as _c } from "react/compiler-runtime";
import { memo, useRef, useState, useMemo } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { _action_validateRecaptcha } from './actions';
export function useReCAPTCHA() {
  const $ = _c(3);
  const IS_ENABLED = process.env.NEXT_PUBLIC_VERCEL_ENV === "production" || process.env.NEXT_PUBLIC_VERCEL_ENV === undefined;
  const ref = useRef(null);
  const [isValidated, setIsValidated] = useState(!IS_ENABLED);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const RecaptchaWrapper = _props => <ReCAPTCHA ref={ref} sitekey={process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY ?? "<undefined>"} onChange={async value => {
      if (value === null) {
        return;
      }
      const isValid = await _action_validateRecaptcha(value);
      setIsValidated(isValid);
    }} onExpired={() => setIsValidated(false)} />;
    t0 = memo(RecaptchaWrapper, _temp);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const MemoizedRecaptchaWrapper = t0;
  let t1;
  if ($[1] !== isValidated) {
    t1 = {
      isValidated,
      Component: MemoizedRecaptchaWrapper
    };
    $[1] = isValidated;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1 as const;
}
function _temp() {
  return true;
}